module.exports = __webpack_public_path__ + "static/img/8.ae67982.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/eng/8.png
// module id = AD87
// module chunks = 0